import {IController, IModule} from "angular";


const css = require('./listeReservekoder.scss');

export class ListeReserverkoderKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
          .component('wmBrukerListeReservekoder', {
              bindings: {
                  reservekoder: '<'
              },
              controller: ListeReserverkoderKontroller.forInjisering(),
              template: require('./listeReservekoder.html')
          });
    }

    static forInjisering() {
        return [ListeReserverkoderKontroller];
    }

    constructor() {
    }

    reservekoder: {[reservekode:string]:boolean}; //settes via bindings/$onChanges

}
